import { ThemeColorName } from '@examdojo/styles';

export type BallPattern = 'solid' | 'hatched' | 'dotted';

export interface UrnBallType {
  readonly id: string;
  readonly label: string;
  readonly color: ThemeColorName;
  readonly pattern: BallPattern;
  readonly initialCount: number;
}

export interface UrnParams {
  readonly ballTypes: UrnBallType[];
  readonly maxCount?: number;
  readonly initialStatementIndex?: number;
  readonly minimal?: boolean;
  readonly initialDrawCount?: number;
  readonly initialWithReplacement?: boolean;
}

export interface PositionedBall {
  readonly id: string;
  readonly cx: number;
  readonly cy: number;
  readonly r: number;
  readonly type: UrnBallType;
}

export const DEFAULT_URN_PARAMS: UrnParams = {
  ballTypes: [
    { id: 'teal', label: 'teal', color: 'teal', pattern: 'hatched', initialCount: 14 },
    { id: 'pink', label: 'pink', color: 'pink', pattern: 'dotted', initialCount: 8 },
    { id: 'purple', label: 'purple', color: 'purple', pattern: 'solid', initialCount: 3 },
  ],
  maxCount: 20,
  initialStatementIndex: 0,
};
